import React from 'react'

import { Fieldset, Textarea } from '@fourthwall/components'

import { useTierContext } from '../../hooks/useTierContext'
import { FormFields } from '../../providers/TierProvider/types'

export const Description = () => {
  const { form, isLoading } = useTierContext()

  return (
    <Fieldset.Row>
      <Fieldset.Item>
        <Textarea
          label="Description (optional)"
          placeholder="Description (optional)"
          disabled={isLoading}
          {...form.getFieldProps(FormFields.description)}
        />
      </Fieldset.Item>
    </Fieldset.Row>
  )
}
